"use client";

import { useHtmlLinksLoader } from '@/hooks/useHtmlLinksLoader';

export default function HtmlLinksLoader() {
  useHtmlLinksLoader();
  return <></>;
} 